import {
  Box,
  Checkbox,
  Dialog,
  DialogContent,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Pagination,
  Stack,
  InputAdornment
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { region, taskAssign } from "../../config/images";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import { addCrops, addMachineryEquipment, crops, deleteCrops, deleteMachineryEquipment, editCrops, editMachineryEquipment, machinery } from "../../config/services";
import { Button } from "../../components/Button/button";

const MachineryData = () => {
  const navigate = useNavigate("/crops");
  const [editMachinery, setEditMachinery] = useState(false);
  const [deleteMachinery, setDeleteMachinery] = useState(false);
  const [addMachinery, setAddMachinery] = useState(false);
  const [importExcel, setImportExcel] = useState(false);
  const [preview, setPreview] = useState(null);

  const [machineryData, setMachineryData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [addMachineryData, setAddMachineryData] = useState("");
  const [addSubCategoryData, setAddSubCategoryData] = useState("");
  const [editMachineryData, setEditMachineryData] = useState("");
  const [editSubCategoryData, setEditSubCategoryData] = useState("");
  const [editId, setEditId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setIsLoading] = useState(false);


  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  const location = useLocation();
  const param = useParams();
  const machineryName = location.state?.name;

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPreview(URL.createObjectURL(file)); // Generate preview URL
    }
  };

  useEffect(() => {
    handlegetmachineryData();
  }, [currentPage]);

  const handlegetmachineryData = async () => {
    try {
      const resp = await machinery(param.id, currentPage, perPage);
      if (resp.status == 200 || resp.status == 201) {
        setMachineryData(resp?.data?.results?.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      setMachineryData([]);
    }
  };
  const filteredMachinery = machineryData.filter((crop) =>
    crop.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddData = async (event) => {
    event.preventDefault();
    if (!addMachineryData) {
      notify("Enter Machinery");
      return;
    }
    if (!addSubCategoryData) {
      notify("Enter Sub Category");
      return;
    }
    const params = {
      machinery_equipment_subcategory: [{
        type_of_machinery_equipment: param.id,
        name: addSubCategoryData
      }],
      name: addMachineryData,
      type_of_machinery: param.id,
    };
    try {
      setIsLoading(true);
      const resp = await addMachineryEquipment(params);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setAddMachinery(false);
        handlegetmachineryData();
        setAddMachineryData("");
        setAddSubCategoryData("");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      notify(error.response.data.message);
      setAddMachinery(false);
    }
  };
  const handleCancel = (e) => {
    if (e) e.preventDefault(); // Prevents default behavior (useful for form buttons)
    setAddMachinery(false); // Closes the popup
    setEditMachinery(false);
    setAddMachineryData("");
    setAddSubCategoryData("");
    setDeleteMachinery(false);
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handleEditPopup = (e, sub_catergory) => {
    setEditId(e.id);
    setEditMachinery(true);
    setEditMachineryData(e.name);
    setEditSubCategoryData(sub_catergory.name);
  };

  const handleEditMachinery = async (event) => {
    event.preventDefault();
    if (!editMachineryData) {
      notify("Enter Machinery");
      return;
    }

    const params = {
      machinery_equipment_subcategory: [{
        type_of_machinery_equipment: param.id,
        name: editSubCategoryData
      }],
      name: editMachineryData,
      type_of_machinery: param.id,
    };
    try {
      setIsLoading(true);
      const resp = await editMachineryEquipment(params, editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setEditMachinery(false);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        handlegetmachineryData();
      }
    } catch (error) {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      notify(error.response.data.message);
      setEditMachinery(false);
    }
  };

  const handleDeletePopup = (e) => {
    setEditId(e.id);
    setDeleteMachinery(true);
  };

  const handleDeleteDta = async () => {
    try {
      setIsLoading(true);
      const resp = await deleteMachineryEquipment(editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setDeleteMachinery(false);
        handlegetmachineryData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notify(error.response.data.message);
      setDeleteMachinery(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const data = [
    {
      srNo: "01",
      name: "Northern",
    },
    {
      srNo: "02",
      name: "Northern",
    },
    {
      srNo: "03",
      name: "Northern",
    },
  ];
  return (
    <>
      <Box className="task-assign-box">
        <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => navigate("/machinery")}
            />
            <img src={region.region} alt="" />
            <Typography variant="h6" gutterBottom>
              {machineryName}
            </Typography>
          </Box>
          <Box className="assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              style={{ marginRight: "10px" }}
              className="delete-btn"
            />
            <button className="deactivate-btn" style={{ marginRight: "10px" }}>
              Demo File
            </button>
            <button
              className="deactivate-btn"
              style={{ marginRight: "10px" }}
              onClick={() => setImportExcel(true)}
            >
              Import Excel
            </button>

            <button
              className="assign-task-btn"
              style={{ marginLeft: "0px" }}
              onClick={() => setAddMachinery(true)}
            >
              Add Machinery
            </button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "4px",
            overflow: "hidden",
            margin: "0px 20px",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box style={{ width: "100%", overflowX: "auto" }}>
          <Table className="region-table pt-3">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "50px" }}>
                  <Checkbox
                    sx={{
                      color: "rgba(225, 230, 244, 1)",
                      borderRadius: "4px",
                      "&.Mui-checked": {
                        color: "rgba(199, 206, 227,1)",
                      },
                    }}
                  />
                </TableCell>
                <TableCell style={{ width: "100px" }}>Sr.No</TableCell>
                <TableCell style={{ width: "200px" }}>{machineryName} Name</TableCell>
                <TableCell>Sub - Category </TableCell>
                <TableCell style={{ width: "100px" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredMachinery.map((machinery, index) => {
                return machinery.machinery_equipment_subcategory.map((sub, subIndex) => (
                  <TableRow key={`${machinery.id}-${sub.id}`}>
                    <TableCell>
                      <Checkbox
                        sx={{
                          color: "rgba(225, 230, 244, 1)",
                          borderRadius: "4px",
                          "&.Mui-checked": {
                            color: "rgba(199, 206, 227,1)",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {index + 1 + (currentPage - 1) * perPage}
                    </TableCell>
                    <TableCell>{machinery.name}</TableCell>
                    <TableCell>{sub.name}</TableCell>
                    <TableCell>
                      <div className="d-flex gap-3">
                        <img
                          src={region.editIcon}
                          alt="Edit"
                          onClick={() => handleEditPopup(machinery, sub)}
                          style={{ cursor: "pointer", height: "23px" }}
                        />
                        <img
                          src={region.deleteIcon}
                          alt="Delete"
                          onClick={() => handleDeletePopup(machinery)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              })}
            </TableBody>
          </Table>
        </Box>
        <Box display="flex" justifyContent="end" alignItems="center">
          <Stack spacing={2} className="mb-2">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handleChange}
              color="primary"
            />
          </Stack>
        </Box>
        <Dialog
          open={addMachinery}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Add Machinery
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter Machinery"
                name="addMachineryData"
                value={addMachineryData}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setAddMachineryData(value);
                  }
                }}
                inputProps={{
                  maxLength: 50,
                }}
                className="mb-3"
              />
              <TextField
                fullWidth
                label="Enter Sub Category"
                name="addSubCategoryData"
                value={addSubCategoryData}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setAddSubCategoryData(value);
                  }
                }}
                inputProps={{
                  maxLength: 50,
                }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <Button
                  title={"Add Machinery"}
                  classname={"assign-task-button"}
                  onClick={handleAddData}
                  loading={loading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={editMachinery}
          onClose={() => setEditMachinery(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Edit Machinery
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter Machinery"
                value={editMachineryData}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setEditMachineryData(value);
                  }
                }}
                inputProps={{
                  maxLength: 50,
                }}
                className="mb-3"
              />
              <TextField
                fullWidth
                label="Enter Sub category"
                value={editSubCategoryData}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setEditSubCategoryData(value);
                  }
                }}
                inputProps={{
                  maxLength: 50,
                }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <Button
                  title={"Update Machinery"}
                  classname={"assign-task-button"}
                  onClick={handleEditMachinery}
                  loading={loading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteMachinery}
          onClose={() => setDeleteMachinery(false)}
          maxWidth="xs"
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <DialogContent className="p-5" style={{ textAlign: "center" }}>
            <Box>
              <img src={region.correct} alt="" />
            </Box>
            <Typography variant="h5" className="pt-4 mb-2">
              <b>Delete this Machinery </b>
            </Typography>
            <Typography
              variant="p"
              className="pt-4"
              style={{ fontSize: "16px" }}
            >
              Are you sure you want to <br />
              delete this Machinery{" "}
            </Typography>
            <div className="d-flex gap-3 pt-4">
              <Button
                title={"Yes"}
                classname={"assign-task-button"}
                onClick={handleDeleteDta}
                loading={loading}
              />
              <button className="assign-task-button" onClick={handleCancel}>
                No
              </button>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={importExcel}
          onClose={() => setImportExcel(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Import Excel
              </h5>
            </div>
          </div>
          <DialogContent>
            {/* <form noValidate autoComplete="off">
                              <TextField
                                fullWidth
                                label="Enter Region"
                                name="taskTitle"
                                // value={taskData.taskTitle}
                                // onChange={handleChange}
                                className="mb-3"
                              />
                
                              <div className="d-flex gap-3 mt-2">
                                <button
                                  className="cancel-button"
                                  // onClick={handleSubmit}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="assign-task-button"
                                  // onClick={handleSubmit}
                                >
                                  Add Region
                                </button>
                              </div>
                            </form> */}
            <Box textAlign="center">
              <input
                type="file"
                accept="image/*"
                id="file-upload"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="file-upload">
                <Box
                  sx={{
                    width: "390px",
                    height: "150px",
                    border: "2px dashed #3C4856",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 10px rgba(160, 160, 160, 0.16)"
                  }}
                >
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img src={region.browseImage} alt="" />
                  )}
                </Box>
              </label>
              <div className="d-flex gap-3 mt-4">
                <button
                  className="cancel-button"
                  onClick={() => setImportExcel(false)}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  onClick={() => setImportExcel(false)}
                >
                  Submit
                </button>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default MachineryData;
